/**
 * @deprecated use same function from '@rchh/lowcode-utils' instead
 */
export function isJSBlock(data) {
  return data && data.type === 'JSBlock';
}